import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getUserSuccess } from "../redux/user/userActions";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import styled from '@mui/material/styles/styled';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: { xl: 480, lg: 480, md: 480, sm: 480, xs: '100%' },
    maxHeight: { xl: 480, lg: 480, md: 480, sm: 480, xs: '100%' },
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    padding: { xl: "3rem 3rem", lg: "3rem 3rem ", md: "3rem 3rem ", sm: "1rem 2rem", xs: "3rem 0rem" }
}));

export default function ThankyouPage() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(location?.state ?? null)
    const [count, setCount] = useState(7);

    useEffect(() => {
        if (!userData && userData === null && location?.state && location?.state !== null) {
            setUserData(location?.state)
        }
    }, [location])

    useEffect(() => {
        if (userData && userData !== null && Object.keys(userData)?.length > 0) {
            setTimeout(() => {
                dispatch(getUserSuccess(userData))
            }, 5000)
        }
    }, [userData])

    useEffect(() => {
        if (count > 0) {
            const timerId = setTimeout(() => {
                setCount(prevCount => prevCount - 1);
            }, 1000)
            return () => clearTimeout(timerId);
        }
    }, [count])

    return (
        <>
            <Helmet>
                <title> Thankyou | Registration completed | Acadlance </title>
            </Helmet>

            <Container>
                <StyledContent>
                    <Box
                        sx={{
                            mb: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img src={"/logo.webp"} alt="Logo" height={40} width="auto" onClick={() => navigate('/login')} />
                    </Box>
                    <Typography variant="h1" sx={{
                        color: '#6d4cb1', fontSize: {
                            xl: "3rem",
                            lg: "3rem",
                            md: "3rem",
                            sm: "1.5rem",
                            xs: "1.1rem"
                        }
                    }}>
                        THANK YOU FOR REGISTERING
                    </Typography>
                    {userData && userData !== null && Object.keys(userData)?.length > 0 ? <>
                        {count !== 0 && <CircularProgress sx={{ color: '#6d4cb1', marginY: '0.5rem' }} />}
                        <Typography variant="p" paragraph sx={{ color: 'text.secondary' }}>
                            {count ? count : ""} <br />
                            {count !== 0 ? "You will be redirected for verification in a moment..." :
                                <Button to="/login" size="large" variant="contained" component={RouterLink}>
                                    Sign in
                                </Button>}
                        </Typography>
                    </> : <>
                        <Typography variant="p" paragraph sx={{ color: 'text.secondary' }}>
                            Please sign-in to your account:
                        </Typography>

                        <Button to="/login" size="large" variant="contained" component={RouterLink}>
                            Sign in
                        </Button>
                    </>}
                </StyledContent>
            </Container>
        </>
    );
}
